import * as angular from 'angular';

export default function BenchmarksConfigService() {
  return {
    getDefaultConfig: function (overrides) {
      var config = {
        templateName: 'benchmarks-plan-modal',
        showSummary: true,
        showBenchmarkControls: true,
        showSavings: true,
        showSpendType: 'planned',
        benchmarkType: 'similar'
      };

      return angular.extend(config, overrides);
    }
  };
}
